import React, { useState } from "react";
import { format, addDays } from "date-fns";
import CommonFilterStructure from "../common-components/CommonFilterStructure";

const LMFilters = ({ userInfoData, allFilters, setAllFilters, onClickReset }) => {
  const [openDateRanger, setOpenDateRanger] = useState(false);
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);

  const handleDateRangeChange = (item) => {
    setRangeState([item?.selection]);

    const formattedStartDate = format(item?.selection?.startDate, "yyyy-MM-dd");
    const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");

    setAllFilters({
      ...allFilters,
      selectedStartDate: formattedStartDate,
      selectedEndDate: formattedEndDate,
    });
  };

  const clearDateRanger = () => {
    setOpenDateRanger(false);
    setRangeState(initialRangeState);
    setAllFilters({
      ...allFilters,
      selectedStartDate: "",
      selectedEndDate: "",
    });
  };

  return (
    <CommonFilterStructure
      from={"live-monitoring"}
      decryptedText={userInfoData}
      setFilters={setAllFilters}
      filters={allFilters}
      onClickReset={onClickReset}
      openDateRanger={openDateRanger}
      handleDateRangeChange={handleDateRangeChange}
      setOpenDateRanger={setOpenDateRanger}
      rangeState={rangeState}
      clearDateRanger={clearDateRanger}
    />
  );
};

export default LMFilters;
